import React, { useState } from 'react'
import { Form, Modal, Button, Space, message } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import RefundForm from './RefundForm'
import { createRefund } from '../../backend-integration/api/paymentAllocation'

const RefundModalWrapper = ({ visible, onClose, preSelectedPatient, onSuccess }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values) => {
    console.log('RefundModalWrapper - handleSubmit called with values:', values)
    setLoading(true)
    try {
      await createRefund({
        ...values,
        patientId: preSelectedPatient._id,
        billingId: preSelectedPatient.billingId
      })

      message.success('Refund request submitted successfully and is pending approval')
      form.resetFields()
      onClose()
      onSuccess?.() // Refresh the account data if callback provided
    } catch (error) {
      console.error('Failed to create refund:', error)
      message.error('Failed to submit refund request')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title={
        <div>
          <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Process Refund</div>
          <div style={{ fontSize: '14px', color: '#666', fontWeight: 'normal' }}>
            Patient: {preSelectedPatient?.name} (ID: {preSelectedPatient?.billingId})
          </div>
        </div>
      }
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={800}
      destroyOnClose={true}
    >
      <RefundForm form={form} preSelectedPatient={preSelectedPatient} onFinish={handleSubmit} />

      <div style={{ textAlign: 'right', marginTop: 24, borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
        <Space>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type='primary' onClick={() => form.submit()} loading={loading} icon={<CheckOutlined />}>
            Submit Refund Request
          </Button>
        </Space>
      </div>
    </Modal>
  )
}

export default RefundModalWrapper
